// extracted by mini-css-extract-plugin
export default {"root":"ExclusionGroupRow_root__0yKBQ","disableMargin":"ExclusionGroupRow_disableMargin__mL1uf","rulesContainer":"ExclusionGroupRow_rulesContainer__2EZbz"};